export default __webpack_public_path__ + "static/media/pending_deposit.e46cd6dd.gif";